<template>
  <vs-dialog auto-width not-padding not-close v-model="active">


    <div class="con-form">
        <pdf 
            ref="pdf"
            :src="url">
        </pdf>
    </div>

  </vs-dialog>
</template>

<script>
import pdf from 'vue-pdf'
// import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      active: false,
      input1: "",
      input2: "",
      checkbox1: false,
      url:null,
    };
  },
  methods: {
    dialog(value) {
       this.active = true;
       this.url = process.env.VUE_APP_BASE_API + "/AuthorPdf?PrintId=" + value;
       this.loading = false;
    },
  },
};
</script>

<style>
</style>